import React from "react";
import { Navigate } from "react-router-dom";
import storage from "../utils/storage";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const PrivateRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const token = storage.getItem("token");
    if (token){
    }
    return token ? (
        <>
        {children}
        </>
    ) : (
        <Navigate to="/login" replace />
    );
};

export default PrivateRoute;
